import { z } from 'zod'

export const CONTACT_TYPE = ['TENANT', 'LANDLORD'] as const

const phoneSchema = z.string().regex(/^\+?[0-9 ()-]{6,20}$/, 'Invalid phone')
const emailSchema = z.string().email().max(254)

export const contactCreateSchema = z.object({
	name:    z.string().trim().min(1).max(200),
	phone:   phoneSchema.optional(),
	email:   emailSchema.optional(),
	type:    z.enum(CONTACT_TYPE),
	source:  z.string().max(50).optional(),
	userId:  z.string().min(1).optional(),
	company: z.string().trim().max(200).optional(),
})

export const contactUpdateSchema = z.object({
	name:    z.string().trim().min(1).max(200).optional(),
	phone:   phoneSchema.optional(),
	email:   emailSchema.optional(),
	source:  z.string().max(50).optional(),
	company: z.string().trim().max(200).optional(),
})

export type ContactCreateInput = z.infer<typeof contactCreateSchema>
export type ContactUpdateInput = z.infer<typeof contactUpdateSchema>
